import React, { useState } from "react";
import { axiosInstance } from "../../config/https";
import { toast } from "react-toastify";
import { useLoader } from "../../context/LoaderContext";

export default function ContactUs() {
  const { startLoader, stopLoader } = useLoader();
  const [contact, setContact] = useState({
    name: "",
    number: "",
    email: "",
    text: "",
  });

  const hanldInputChange = (e) => {
    const { name, value } = e.target;
    setContact({
      ...contact,
      [name]: value,
    });
  };

  const send = () => {
    startLoader();
    axiosInstance
      .post("/api/contacts/", contact)
      .then((response) => {
        stopLoader();
        if (response.status === 200 || response.status === 201) {
          setContact({
            name: "",
            number: "",
            email: "",
            text: "",
          });
          toast.success("Contact Details sent successfully");
        } else {
          toast.success("Something went wrong");
        }
      })
      .catch(() => {
        stopLoader();
        toast.success("Something went wrong");
      });
  };

  return (
    <section className="about-sec pc-p-3">
      <div className="container-fluid px-5">
        <div className="primary-heading color-dark">
          <h3>Contact Us</h3>
        </div>
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6 col-12">
            <div className="about-img">
              <img src="/assets/contact-img.png" alt="contact" />
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="contact-form">
              <form action="" className="main-form">
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control px-3"
                    placeholder="Your Name"
                    name="name"
                    value={contact.name}
                    onChange={hanldInputChange}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control px-3"
                    placeholder="Phone Number"
                    name="number"
                    value={contact.number}
                    onChange={hanldInputChange}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control px-3"
                    placeholder="Email Address"
                    name="email"
                    value={contact.email}
                    onChange={hanldInputChange}
                  />
                </div>
                <div className="form-group">
                  <textarea
                    className="form-control px-3"
                    rows={10}
                    placeholder="How Can We Help ?"
                    name="text"
                    value={contact.text}
                    onChange={hanldInputChange}
                  />
                </div>
                <button
                  className="primary-btn primary-bg"
                  type="button"
                  onClick={send}
                >
                  Send A Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
